document.addEventListener('DOMContentLoaded', function () {
  const DESKTOP_QUERY = window.matchMedia('(min-width: 990px)');

  function initGalleryHeights() {
    if (!DESKTOP_QUERY.matches) return;

    document.querySelectorAll('.media-thumbnails-left').forEach(function (gallery) {
      const viewerList = gallery.querySelector('.product__media-list');
      const thumbSlider = gallery.querySelector('.thumbnail-slider');

      if (!viewerList || !thumbSlider) return;

      // 让左侧缩略图区域高度 = 右侧大图区域高度
      const viewerRect = viewerList.getBoundingClientRect();
      const height = viewerRect.height;

      thumbSlider.style.height = height + 'px';
      thumbSlider.style.maxHeight = height + 'px';
    });
  }

  // 点击缩略图时，自动把当前缩略图滚到容器中间
  function initThumbnailAutoScroll() {
    document.querySelectorAll('.media-thumbnails-left .thumbnail').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!DESKTOP_QUERY.matches) return;

        const item = btn.closest('.thumbnail-list__item');
        const container = btn.closest('.thumbnail-slider');
        if (!item || !container) return;

        const containerRect = container.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();

        const offset = itemRect.top - containerRect.top;
        const target =
          container.scrollTop + offset - containerRect.height / 2 + itemRect.height / 2;

        container.scrollTo({
          top: target,
          behavior: 'smooth'
        });
      });
    });
  }

  initGalleryHeights();
  initThumbnailAutoScroll();

  window.addEventListener('resize', function () {
    initGalleryHeights();
  });
});